import React from 'react';
import { NavLink } from 'react-router-dom';
import { Button, HStack, Icon, IconButton, Text, Tooltip } from '@chakra-ui/react';
import PropTypes from 'prop-types';

const NavBarLink = ({ to, title, hoverTitle, icon, variant, onClick, style, dataAnalyticsId = undefined, cypressId = undefined }) => {
  const colorScheme = variant === 'accent' ? 'brand' : 'darkNeutral';

  if (style === 'expanded') {
    return (
      <NavLink style={{ textDecoration: 'none', color: 'inherit' }} to={to} onClick={onClick}>
        <Button
          _focus={{ outline: 'none', boxShadow: 'none' }}
          colorScheme={colorScheme}
          data-analytics-id={dataAnalyticsId}
          data-cy={cypressId}
          dusk={dataAnalyticsId}
          fontWeight="medium"
          px={6}
          size="navFull"
          variant={variant}
          width={['200px', '200px', '200px', '224px', '224px']}
        >
          <HStack
            spacing={4}
            width="inherit"
          >
            <Icon as={icon} boxSize="24px" />
            <Text>{title}</Text>
          </HStack>
        </Button>
      </NavLink>
    );
  }

  return (
    <Tooltip label={hoverTitle ?? title} placement="right">
      <NavLink to={to} onClick={onClick}>
        <IconButton
          _focus={{ outline: 'none', boxShadow: 'none' }}
          colorScheme={colorScheme}
          data-analytics-id={dataAnalyticsId}
          data-cy={cypressId}
          dusk={dataAnalyticsId}
          icon={<Icon as={icon} boxSize="24px" />}
          size="navIcon"
          variant={variant}
        />
      </NavLink>
    </Tooltip>
  );
};

NavBarLink.propTypes = {
  dataAnalyticsId: PropTypes.string,
  cypressId: PropTypes.string,
  to: PropTypes.string,
  title: PropTypes.string,
  hoverTitle: PropTypes.string,
  icon: PropTypes.func,
  variant: PropTypes.string,
  onClick: PropTypes.func,
  style: PropTypes.oneOf(['expanded', 'collapsed'])
};

export default NavBarLink;
